// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__CnPrk","loader--svg":"Loader_loader--svg__CUWpt"};